import { render, staticRenderFns } from "./InformationRfidModal.vue?vue&type=template&id=3d6f02e8"
import script from "./InformationRfidModal.vue?vue&type=script&lang=js"
export * from "./InformationRfidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports